import orm from 'models/orm'
import { Fields } from 'models/Product'
import { createSelector as createOrmSelector } from 'redux-orm'

export const selectProducts = createOrmSelector(
  orm,
  (state: any) => state.orm,
  (session: any): Fields[] => {
    return session.Product.all().toRefArray()
  }
)
